import { Container } from '@almbrand/container';
import { Grid, GridCell } from '@almbrand/grid';
import { HeaderComponent, MultiplePageTemplate } from 'components';
import { NotificationBannerComponent } from 'components/2-molecules';
import { IsPackageComponentContext } from 'context/IsPackageComponentContext';
import { PageContext } from 'context/PageContext';
import { useCustomerModal, useDataLoadEvents, useFetchCustomer, useFormSubmit, useTracking } from 'hooks';
import { memo, useContext, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { loadStaticFieldsToForm } from 'store/slices/calculatorFormSlice';
import { setPlaceholderDefinitions } from 'store/slices/placeholderSlice';
import { submitHiddenFieldsToForm } from '../../../services/HiddenFieldService';
import { loadDefaultsToForm } from '../../../services/PageService';
import styles from './ProductCalculatorPage.module.scss';

export const ProductCalculatorPage: React.FC<PageModel> = memo(() => {
	const pageContext = useContext(PageContext);
	const { headerContent, notificationBannerContent, pageModel, metaArea } = pageContext ?? {};

	const { onSubmit } = useFormSubmit();
	const { isVisible } = useContext(IsPackageComponentContext);

	const dispatch = useAppDispatch();
	if (pageModel?.hiddenFields) {
		submitHiddenFieldsToForm(pageModel.hiddenFields);
	}

	useTracking();

	useEffect(() => {
		dispatch(setPlaceholderDefinitions(metaArea));
		dispatch(loadStaticFieldsToForm(metaArea));
		loadDefaultsToForm(metaArea, onSubmit);
	}, []);

	useFetchCustomer();
	useCustomerModal();
	useDataLoadEvents();

	return (
		<>
			<div
				className={
					isVisible
						? styles.ProductCalculatorPage__HeaderComponent__packages
						: styles.ProductCalculatorPage__HeaderComponent
				}
			>
				<Container
					desktopWidth='1600'
					tabletWidth='1280'
					mobileWidth='744'
				>
					<Grid>
						<GridCell>
							<HeaderComponent {...headerContent} />
							{notificationBannerContent && (
								<NotificationBannerComponent {...notificationBannerContent} />
							)}
						</GridCell>
					</Grid>
				</Container>
			</div>
			<Container
				desktopWidth={isVisible ? 'fullWidth' : '1600'}
				tabletWidth='fullWidth'
				mobileWidth={isVisible ? 'fullWidth' : '360'}
				noPadding
			>
				{/* <Container
					desktopWidth='2500'
					tabletWidth='1600'
					mobileWidth='fullWidth'
				>
					<Grid
						container
						nogutter
					>
						<GridCell desktopWidth='9col'> */}
				<MultiplePageTemplate pageModel={pageModel} />
				{/* </GridCell>
					</Grid>
				</Container> */}
			</Container>
			{/* {!isVisible && (
				<Container mobileWidth='fullWidth'>
					<div
						style={{
							height: 128,
							borderTopLeftRadius: 32,
							borderTopRightRadius: 32,
							background: '#FFF',
							display: 'flex',
							justifyContent: 'center',
							padding: '32px 40px 40px 40px',
							position: 'relative',
						}}
					>
						<Headline
							title='NAVIGATION'
							size='default'
							variant='h2'
						/>
					</div>
				</Container>
			)} */}
		</>
	);
});

ProductCalculatorPage.displayName = 'ProductCalculatorPage';
